import { Search, FileText, Code2, Rocket } from "lucide-react";
import { Reveal } from "./Reveal";

const STEPS = [
  { icon: Search, title: "Discover", desc: "We learn about your business, customers and goals" },
  { icon: FileText, title: "Plan", desc: "We agree on the structure, content, features and visual direction" },
  { icon: Code2, title: "Build", desc: "We build your website and carefully refine every detail" },
  { icon: Rocket, title: "Launch & Handover", desc: "We test, publish and hand over your finished website" },
];

export const Process = () => (
  <section id="process" className="px-5 md:px-10 py-10 md:py-16 scroll-mt-24">
    <div className="max-w-[1440px] mx-auto">
      <Reveal>
        <div className="glass-panel px-6 py-12 md:px-14 md:py-16">
          <div className="text-center max-w-2xl mx-auto">
            <p className="text-xs font-bold tracking-[0.22em] text-[#39D5FF] mb-4">HOW IT WORKS</p>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-[#F7FAFF]">
              A Simple Process. <span className="text-gradient">Powerful Results.</span>
            </h2>
          </div>

          <div className="hidden md:block mt-16 relative">
            <div className="absolute top-9 left-[12%] right-[12%] process-connector" aria-hidden="true" />
            <div className="grid grid-cols-4 gap-6 relative">
              {STEPS.map((s, i) => (
                <Reveal key={s.title} delay={i * 0.1}>
                  <div className="flex flex-col items-center text-center" data-testid="process-step">
                    <span className="grid place-items-center w-[72px] h-[72px] rounded-2xl bg-[rgba(8,29,59,0.9)] border border-[rgba(65,176,255,0.55)] shadow-[0_0_28px_rgba(0,168,255,0.25)]">
                      <s.icon size={28} className="text-[#39D5FF]" />
                    </span>
                    <span className="mt-3 text-xs font-bold text-[#7F92AE]">STEP {i + 1}</span>
                    <h3 className="mt-1 text-xl font-bold text-[#F7FAFF]">{s.title}</h3>
                    <p className="mt-2 text-sm text-[#AEBFD8] leading-relaxed max-w-[220px]">{s.desc}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="md:hidden mt-12 flex flex-col gap-0">
            {STEPS.map((s, i) => (
              <div key={s.title} className="flex gap-4" data-testid="process-step-mobile">
                <div className="flex flex-col items-center">
                  <span className="grid place-items-center w-14 h-14 shrink-0 rounded-2xl bg-[rgba(8,29,59,0.9)] border border-[rgba(65,176,255,0.55)] shadow-[0_0_22px_rgba(0,168,255,0.25)]">
                    <s.icon size={24} className="text-[#39D5FF]" />
                  </span>
                  {i < STEPS.length - 1 && <div className="process-connector-v flex-1 my-1" aria-hidden="true" />}
                </div>
                <div className="pb-8 pt-1">
                  <span className="text-xs font-bold text-[#7F92AE]">STEP {i + 1}</span>
                  <h3 className="text-lg font-bold text-[#F7FAFF]">{s.title}</h3>
                  <p className="mt-1 text-sm text-[#AEBFD8] leading-relaxed">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
